export default "__VITE_ASSET__CSF2RxzW__"